(function () {
  // Scroll-reveal for every animated element
  var revealEls = document.querySelectorAll('[data-mph-reveal]');
  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  // Count-up animation for numeric stat values (skips non-numeric ones like "Free" or "#1")
  var countEls = document.querySelectorAll('[data-mph-count]');
  if (countEls.length) {
    var countObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var raw = el.dataset.target || '';
        var match = raw.match(/[\d,.]+/);
        if (!match) { obs.unobserve(el); return; }

        var numeric = parseFloat(match[0].replace(/,/g, ''));
        if (isNaN(numeric)) { obs.unobserve(el); return; }

        var prefix = raw.slice(0, match.index);
        var suffix = raw.slice(match.index + match[0].length);
        var duration = 1200;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(numeric * eased);
          el.textContent = prefix + current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = raw;
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    countEls.forEach(function (el) { countObserver.observe(el); });
  }
})();